"use client";

import React from "react";
import styles from "./count-badge.module.scss";

interface CountBadgeProps {
  count: number;
  label: string;
  isHealthy: boolean;
  onClick?: () => void;
}

const CountBadge: React.FC<CountBadgeProps> = ({
  count,
  label,
  isHealthy,
  onClick
}) => {
  return (
    <div
      className={`${styles.badge} ${isHealthy ? styles.badgeHealthy : styles.badgeUnhealthy}`}
      onClick={onClick}
    >
      {count} {label}
    </div>
  );
};

export default CountBadge;
